import * as Dialog from '@radix-ui/react-dialog'
import * as commonStyles from '../../styles/common.css.ts'
import CloseIcon from '../icons/close-icon.svg?react'
import { ToolVendorLogo } from '../third-party-branding/tool-logo'
import { SUPPORTED_TOOL_VENDORS } from '../third-party-branding/tool-vendors'
import * as styles from './onboarding-modal.css.ts'

type OnboardingModalProps = {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export function OnboardingModal({ isOpen, setIsOpen }: OnboardingModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.alertDialogOverlay} />
        <Dialog.Content className={styles.alertDialogContent} onOpenAutoFocus={event => event.preventDefault()}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <div className={styles.headerContainer}>
              <Dialog.Title className={styles.welcome}>Welcome! 👋</Dialog.Title>
              <Dialog.Close aria-label="Close onboarding dialog">
                <CloseIcon className={styles.closeIcon} />
              </Dialog.Close>
            </div>

            <Dialog.Description asChild>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <h1 className={styles.mainHeading}>Connect your repository and add findings</h1>
                <p className={styles.paragraph}>
                  Once a repository is connected, designate results from your SAST, SCA, DAST, or secrets scanner to get
                  in-depth triage analysis and fixes for findings.{' '}
                  <a
                    href="https://docs.pixee.ai/code-scanning-tools/overview"
                    target="_blank"
                    className={commonStyles.link}
                  >
                    Learn more
                  </a>{' '}
                  about integrating with supported tools.
                </p>
              </div>
            </Dialog.Description>
          </div>
          <ul className={styles.toolLogos} aria-label="Supported tools">
            {SUPPORTED_TOOL_VENDORS.map(vendor => (
              <li key={vendor} className={styles.toolLogoItem}>
                <ToolVendorLogo vendor={vendor} size="medium+" />
              </li>
            ))}
          </ul>
          <div className={styles.onboardingDialogFooter}>
            <p className={styles.additionalToolIntegrations}>Our list of supported tools continues to grow.</p>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
